<ng-container *rxLet="bp.smallScreen$; let isSmallScreen">
  <mat-toolbar [ngStyle]="{ height: hideToolbar ? 0 : undefined }">
    <button mat-icon-button (click)="sidenav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <ng-content select="[toolbar-left]" style="display: contents"> </ng-content>
    <span class="spacer"></span>
    <ng-content select="[toolbar-center]" style="display: contents">
    </ng-content>
    <span class="spacer"></span>
    <ng-content select="[toolbar-right]" style="display: contents">
    </ng-content>
  </mat-toolbar>
  <mat-sidenav-container>
    <mat-sidenav
      #sidenav
      [mode]="isSmallScreen ? 'over' : 'side'"
      class="mat-elevation-z0"
      [opened]="!isSmallScreen"
    >
      <ng-content select="[left]" style="display: contents"></ng-content>
    </mat-sidenav>

    <mat-sidenav-content>
      <ng-content select="[main]" style="display: contents"> </ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
